module.exports = require('./NspDark')
